import React, { useMemo } from 'react';
import { Center, Container } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { appTranslate } from '../../i18n';
import { Table, TableHeader, TableRow, TableHead, TableBody } from '../shared/Table';
import { getSubscriptionTiersTable } from '../../constants/vendors/microsoft/getSubscriptionTiersTable';
import { PricingDetails, SubscriptionTier } from '../../../type';
import { ANCHOR_COMPARE_PACKAGES_SECTION } from '../../constants/anchors';
import { SubscriptionTiersHeader } from './SubscriptionTiersHeader';
import { SubscriptionTiersRow } from './SubscriptionTiersRow';

interface ComparePackagesProps {
    pricingDetails: PricingDetails[];
    onChooseTier: (tierName: SubscriptionTier) => void;
}

export const ComparePackages = ({ pricingDetails, onChooseTier }: ComparePackagesProps) => {
    const subscriptionTiersTable = useMemo(() => getSubscriptionTiersTable(), []);

    return (
        <Center rowGap="10" paddingX={{ default: '4', xl: '0' }}>
            <Heading as="h2" size="h_xl" id={ANCHOR_COMPARE_PACKAGES_SECTION}>
                {appTranslate('compare_packages.title')}
            </Heading>

            <Container maxWidth={theme.numericBreakpoints.xl} width="100%">
                <Table>
                    <TableHeader>
                        <TableRow isSticky>
                            <TableHead isSticky width="310px" zIndex="1" />
                            {subscriptionTiersTable.tiersDetails.map((tierDetail) => {
                                const currentPricingDetails = pricingDetails.find(
                                    (pricingDetail) => pricingDetail.tierName === tierDetail.id
                                );

                                if (!currentPricingDetails) return <TableHead key={tierDetail.id} />;

                                return (
                                    <TableHead key={tierDetail.id}>
                                        <SubscriptionTiersHeader
                                            tierDetails={tierDetail}
                                            onChooseTier={() => onChooseTier(tierDetail.id)}
                                            pricingDetails={currentPricingDetails}
                                        />
                                    </TableHead>
                                );
                            })}
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {subscriptionTiersTable.serviceOptions.map((option) => (
                            <SubscriptionTiersRow
                                key={option.id}
                                serviceOption={option}
                                tierDetails={subscriptionTiersTable.tiersDetails}
                            />
                        ))}
                    </TableBody>
                </Table>
            </Container>
        </Center>
    );
};
